export default __webpack_public_path__ + "static/media/bn15.08d15edc.jpg";